export default __webpack_public_path__ + "static/definition-card-edit-dark-mode-f0a78b90c947fe90428d29826b49cc82.png";